import { chatTypes } from "./chat.types";

const INITIAL_STATE = {
    conversations:[]
}

const chatReducer = (state=INITIAL_STATE,action) => {
    switch (action.type) {
        case chatTypes.SET_MESSAGES:
            return {
                ...state,
                conversations:action.payload
            }
        case chatTypes.SET_MESSAGES_FAILED:
            return {
                ...state,
                conversations:[]
            }
        case chatTypes.SET_MESSAGE:
            return {
                ...state,
                conversations:[
                    ...state.conversations,
                    action.payload
                ]
            }
        default:
            return state;
    }
}


export default chatReducer;